import { ChildCriteria } from '../children/childUtilityInterfaces';
import type { CartItem, CartItemTypeEnum } from './cart-item';
import type { CartChild, CartChildDTO } from './child';

export enum SponsorshipItemTypeEnum {
  Selected = 'Selected',
  FirstPayment = 'FirstPayment',
  EPayment = 'EPayment',
  LongestWaiting = 'LongestWaiting',
  // eslint-disable-next-line @typescript-eslint/no-shadow
  ChildCriteria = 'ChildCriteria',
}

export interface SponsorshipPayloadBase {
  sponsorshipType: SponsorshipItemTypeEnum;
}
export interface SponsorshipSelectedPayload {
  sponsorshipType: SponsorshipItemTypeEnum.Selected;
  globalId: string;
  sourceCode?: string;
}
export interface SponsorshipFirstPaymentPayload {
  sponsorshipType: SponsorshipItemTypeEnum.FirstPayment;
  globalId: string;
  sourceCode: string;
  holdId?: string;
  isConsignment?: boolean;
}
export interface SponsorshipEPaymentPayload {
  sponsorshipType: SponsorshipItemTypeEnum.EPayment;
  globalId: string;
}
export interface SponsorshipLongestWaitingPayload {
  sponsorshipType: SponsorshipItemTypeEnum.LongestWaiting;
  quantity: number;
}
export interface SponsorshipChildCriteriaPayload {
  sponsorshipType: SponsorshipItemTypeEnum.ChildCriteria;
  quantity: number;
  criteria: ChildCriteria;
}

export type SponsorshipPayload = SponsorshipPayloadBase &
  (
    | SponsorshipSelectedPayload
    | SponsorshipFirstPaymentPayload
    | SponsorshipEPaymentPayload
    | SponsorshipLongestWaitingPayload
    | SponsorshipChildCriteriaPayload
  );

/**
 * The incoming request payload for a Sponsorship item
 */
export interface CartItemSponsorshipPayload {
  itemType: CartItemTypeEnum.Sponsorship;
  sponsorship: SponsorshipPayload;
  isUpsell?: CartItem['isUpsell'];
}

export interface CartItemSponsorshipSelected {
  sponsorshipType: SponsorshipItemTypeEnum.Selected;
  globalId: string;
  sourceCode?: string;
}

export interface CartItemSponsorshipFirstPayment {
  sponsorshipType: SponsorshipItemTypeEnum.FirstPayment;
  globalId: string;
  sourceCode: string;
}

export interface CartItemSponsorshipEPayment {
  sponsorshipType: SponsorshipItemTypeEnum.EPayment;
  globalId: string;
}

export interface CartItemSponsorshipLongestWaiting {
  sponsorshipType: SponsorshipItemTypeEnum.LongestWaiting;
  reservedChildren: CartChild[];
}

export interface CartItemSponsorshipChildCriteria {
  sponsorshipType: SponsorshipItemTypeEnum.ChildCriteria;
  criteria: ChildCriteria;
  reservedChildren: CartChild[];
}

export interface CartItemSponsorshipLongestWaitingDTO extends Omit<
  CartItemSponsorshipLongestWaiting,
  'reservedChildren'
> {
  reservedChildren: CartChildDTO[];
}
export interface CartItemSponsorshipChildCriteriaDTO extends Omit<
  CartItemSponsorshipChildCriteria,
  'reservedChildren'
> {
  reservedChildren: CartChildDTO[];
}

/**
 * An outgoing response Sponsorship item:
 */
export interface CartItemSponsorship {
  itemType: CartItemTypeEnum.Sponsorship;
  title: string;
  /**
   * @discriminator sponsorshipType
   */
  sponsorship:
    | CartItemSponsorshipSelected
    | CartItemSponsorshipFirstPayment
    | CartItemSponsorshipEPayment
    | CartItemSponsorshipLongestWaiting
    | CartItemSponsorshipChildCriteria;
  child?: CartChild;
}

export interface CartItemSponsorshipDTO extends Omit<
  CartItemSponsorship,
  'sponsorship'
> {
  sponsorship:
    | CartItemSponsorshipSelected
    | CartItemSponsorshipFirstPayment
    | CartItemSponsorshipEPayment
    | CartItemSponsorshipLongestWaitingDTO
    | CartItemSponsorshipChildCriteriaDTO;
}
